import React, { useEffect, useMemo, useState, useCallback, useRef } from "react";
import {
  Button,
  Checkbox,
  Icon,
  Input,
  Popup,
  Image,
  Form,
  Dropdown,
  Dimmer,
  Loader,
} from "semantic-ui-react";
// MUI

import htmlParse from "html-react-parser";

// UX
import CardOpenEncounterUX from "./CardOpenEncounterUX";

// Common
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";
import SearchBoxDropdown from "react-lib/appcon/common/SearchBoxDropdown";
import ModInfo from "react-lib/apps/common/ModInfo";
import SnackMessage from "react-lib/apps/common/SnackMessage";
import ModAuthen from "react-lib/apps/common/ModAuthen";
import ModConfirmCNMI from "react-lib/apps/common/cnmi/ModConfirm";

// Interface
import { DOCTOR_ORDER_MAPPING_ICON } from "../REG/REGInterface";

import { formatDatetime } from "react-lib/utils/dateUtils";

// Config
import CONFIG from "config/config";
import { useIntl } from "react-intl";

const IMAGES = {
  //icon
  mobilePhoneLock: "/static/images/regSearch/mobilePhoneLock.png",
  call_message_yellow: "/static/images/regSearch/call-message-yellow.png",
};

const BUTTON_ACTIONS = {
  open_en_app: "open_encounter_appointment",
  sync_en_app: "open_encounter_sync_appointment",
  print_visit_slip_form: "print_visit_slip_form",
  update: "UPDATE",
  save: "SAVE",
};

const CARD_OPEN_ENCOUNTER = "CreateUpdateEncounter";

const ACTION_OPEN_EN_APP = `${CARD_OPEN_ENCOUNTER}_${BUTTON_ACTIONS.open_en_app}`;
const ACTION_SYNC_EN_APP = `${CARD_OPEN_ENCOUNTER}_${BUTTON_ACTIONS.sync_en_app}`;
const ACTION_UPDATE = `${CARD_OPEN_ENCOUNTER}_${BUTTON_ACTIONS.update}`;
const ACTION_SAVE = `${CARD_OPEN_ENCOUNTER}_${BUTTON_ACTIONS.save}`;
const ACTION_PRINT_VISIT_SLIP = `${CARD_OPEN_ENCOUNTER}_${BUTTON_ACTIONS.print_visit_slip_form}`;

const CardOpenEncounter = (props: any) => {
  console.debug("debug ~ CardOpenEncounter ~ props:", props);
  const intl = useIntl();
  const bottomRef = useRef<HTMLDivElement | null>(null);
  // Mod
  const [openDialog, setOpenDialog] = useState(false);
  const [openErrorMessageDegree, setOpenErrorMessageDegree] = useState(false);
  const [openErrorVerified, setOpenErrorVerified] = useState(false);
  const [note, setNote] = useState("");
  const [showEncounterEditor, setShowEncounterEditor] = useState(false);
  const [pregnancyData, setPregnancyData] = useState({
    pregnancy_period: 0,
    pregnancy_status: 1,
  });

  // Effect
  useEffect(() => {
    props.runSequence({
      sequence: "CreateUpdateEncounter",
      card: "CreateUpdateEncounter",
      form: props.form,
      isEditEncounter: props.isEditEncounter,
      editEncounterId: props.editEncounterId,
      defaultAppointmentId: props.defaultAppointmentId,
      restart: true,
      isNoneFilterDate: true,
    });

    if (props.isEditEncounter) {
      setShowEncounterEditor(true);
    }
  }, []);

  useEffect(() => {
    setPregnancyData({
      pregnancy_status: props.CreateUpdateEncounterSequence?.pregnancy_status || 1,
      pregnancy_period: props.CreateUpdateEncounterSequence?.pregnancy_period || 0,
    });
  }, [
    props.CreateUpdateEncounterSequence?.pregnancy_status,
    props.CreateUpdateEncounterSequence?.pregnancy_period,
  ]);

  useEffect(() => {
    if (
      props.successMessage?.[CARD_OPEN_ENCOUNTER] &&
      !props.isEditEncounter &&
      showEncounterEditor
    ) {
      setShowEncounterEditor(false);

      props.setProp(`successMessage.${CARD_OPEN_ENCOUNTER}`, null);
    }
  }, [props.successMessage, props.isEditEncounter]);

  useEffect(() => {
    return () => {
      props.setProp(`successMessage.${CARD_OPEN_ENCOUNTER}`, null);
      props.setProp(`errorMessage.${CARD_OPEN_ENCOUNTER}`, null);
      props.setProp(`CreateUpdateEncounterSequence.selectedEncounterItems`, []);
    };
  }, []);

  useEffect(() => {
    if (showEncounterEditor) {
      // รอให้ DOM อัปเดตก่อน scroll (เผื่อ content เพิ่งถูก render)
      setTimeout(() => {
        bottomRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "end",
        });
      }, 100); // ปรับ delay ตามความเหมาะสม
    }
  }, [showEncounterEditor]);

  // Memo Callback
  const selectedEncounter = useMemo(() => {
    return props.CreateUpdateEncounterSequence?.selectedEncounter || {};
  }, [props.CreateUpdateEncounterSequence?.selectedEncounter]);

  const printableList = useMemo(() => {
    return (props.CreateUpdateEncounterSequence?.encounterList || []).filter(
      (item: any) => item.status !== "CANCELED",
    );
  }, [props.CreateUpdateEncounterSequence?.encounterList]);

  // Callback
  const handleOpenEncounterAppointment = useCallback((data: any) => {
    props.runSequence({
      sequence: "CreateUpdateEncounter",
      action: "open_encounter_appointment",
      card: CARD_OPEN_ENCOUNTER,
      confirmed: data.confirmed,
      onSuccess: props.onOpenedAppointment,
    });
  }, [props.onOpenedAppointment]);

  const handleSyncEncounterAppointment = useCallback(() => {
    props.runSequence({
      sequence: "CreateUpdateEncounter",
      action: "open_encounter_sync_appointment",
      card: CARD_OPEN_ENCOUNTER,
    });
  }, []);

  const handleEditEncounter = () => {
    if (
      props.CreateUpdateEncounterSequence?.student !== null
        ? props.CreateUpdateEncounterSequence?.student_degree === null
        : false
    ) {
      setOpenErrorMessageDegree(true);
    } else {
      props.runSequence({
        sequence: "CreateUpdateEncounter",
        action: "update",
        pregnancy: pregnancyData,
        card: CARD_OPEN_ENCOUNTER,
        buttonLoadKey: ACTION_UPDATE,
        isEditEncounter: props.isEditEncounter,
        onUpdated: props.onUpdated,
      });
    }
  };

  // const handleSaveEncounter = useCallback(() => {
  //   if (
  //     props.CreateUpdateEncounterSequence?.student !== null
  //       ? props.CreateUpdateEncounterSequence?.student_degree === null
  //       : false
  //   ) {
  //     setOpenErrorMessageDegree(true);
  //   } else {
  //     if (selectedEncounter?.id !== undefined) {
  //       props.runSequence({
  //         sequence: "CreateUpdateEncounter",
  //         action: "clearData",
  //       });
  //     } else {
  //       props.runSequence({
  //         sequence: "CreateUpdateEncounter",
  //         action: "create",
  //         pregnancy: pregnancyData,
  //         card: CARD_OPEN_ENCOUNTER,
  //         buttonLoadKey: ACTION_SAVE,
  //       });
  //     }
  //   }
  // }, [props.CreateUpdateEncounterSequence?.student, pregnancyData]);

  const handleSaveEncounter = () => {
    if (
      props.CreateUpdateEncounterSequence?.student !== null
        ? props.CreateUpdateEncounterSequence?.student_degree === null
        : false
    ) {
      setOpenErrorMessageDegree(true);
    } else {
      if (selectedEncounter?.id !== undefined) {
        props.runSequence({
          sequence: "CreateUpdateEncounter",
          action: "clearData",
        });
      } else {
        props.runSequence({
          sequence: "CreateUpdateEncounter",
          action: "create",
          pregnancy: pregnancyData,
          card: CARD_OPEN_ENCOUNTER,
          buttonLoadKey: ACTION_SAVE,
        });
      }
    }
  };

  const handleRowProps = useCallback(
    (_state: any, rowInfo: any, _column: any, _instance: any) => {
      return {
        style: {
          backgroundColor:
            selectedEncounter &&
            rowInfo?.original?.id &&
            rowInfo?.original?.id === selectedEncounter?.id
              ? "var(--primary-select-background)"
              : "white",
        },
        onClick: async () => {
          await props.runSequence({
            sequence: "CreateUpdateEncounter",
            action: "select",
            item: rowInfo?.original,
          });

          setShowEncounterEditor(true);
        },
      };
    },
    [selectedEncounter],
  );

  const handleOpenEncounter = useCallback(() => {
    if (props.patient?.profile_status === "NOT_VERIFIED") {
      setOpenErrorVerified(true);
    } else {
      props.runSequence({
        sequence: "CreateUpdateEncounter",
        action: "clearData",
      });

      setShowEncounterEditor(true);
    }
  }, [props.patient]);

  const handleCheckEncounterAppointment = useCallback(
    (item: any) => (e: any) => {
      props.runSequence({
        sequence: "CreateUpdateEncounter",
        action: "checked_encounter_appointment",
        appointmentId: item.id,
      });
    },
    [],
  );

  const changeEncounter = useCallback(
    (key: string) => (e: any, v: any) => {
      if (key === "student" && v.value === "") {
        props.setProp(`CreateUpdateEncounterSequence`, {
          ...props.CreateUpdateEncounterSequence,
          student: "",
          student_degree: null,
        });
      } else {
        props.setProp(`CreateUpdateEncounterSequence.${key}`, v.value);
      }
    },
    [],
  );

  const changePregnancy = useCallback(
    (key: string) => (e: any, v: any) => {
      setPregnancyData((pregnancyData) => ({
        ...pregnancyData,
        ...(key === "pregnancy_status" && { pregnancy_status: v.value }),
        ...(key === "pregnancy_period" && { pregnancy_period: v.value }),
      }));
    },
    [],
  );

  const handleCheck = useCallback(
    (e: any, data: any) => {
      e.stopPropagation();

      let ids = [...(props.CreateUpdateEncounterSequence?.selectedEncounterItems || [])];

      if (data.checked) {
        ids.push(data.name);
      } else {
        ids = ids.filter((id) => id !== data.name);
      }

      props.setProp("CreateUpdateEncounterSequence.selectedEncounterItems", ids);
    },
    [props.CreateUpdateEncounterSequence?.selectedEncounterItems],
  );

  const handleCheckAll = useCallback(
    (_e: any, data: any) => {
      let ids: any[] = [];

      if (data.checked) {
        ids = printableList.map((item: any) => item.id);
      }

      props.setProp("CreateUpdateEncounterSequence.selectedEncounterItems", ids);
    },
    [printableList],
  );

  // Memo
  const disabledEditEncounter = useMemo(() => {
    return (
      (Object.keys(selectedEncounter.approve_info || {}).length && CONFIG.RAKSTHAI_ENCOUNTER_STATUS) ||
      selectedEncounter.type === "OTH"
    );
  }, [selectedEncounter]);

  const showDrugPurchase = useMemo(() => {
    return props.divisionType === "ห้องยา";
  }, [props.divisionType]);

  const generateOrder = (orders: any[]) => {
    let sortingOrderType: any = [];

    Object.keys(DOCTOR_ORDER_MAPPING_ICON).forEach((order_type: any) => {
      // find match order type and status
      let target = orders.filter((order) => order.type.includes(order_type));
      if (target?.length > 0) {
        sortingOrderType.push({
          image: DOCTOR_ORDER_MAPPING_ICON[order_type]["appointment_or_cancel"],
          items: target?.map((i) => i.summary_detail),
          ...(order_type === "doctorconsultorder" ? { icon: "user md" } : {}),
        });
      }
    });
    console.log("generate Order: ", sortingOrderType);
    return sortingOrderType;
  };

  const errorMessage = useMemo(() => {
    const errors = props.errorMessage?.[CARD_OPEN_ENCOUNTER];
    const errorData = errors ?? {};

    return Array.isArray(errorData?.detail) && typeof errorData?.error === "string"
      ? { deviceError: errorData, error: null }
      : { deviceError: null, error: errors };
  }, [props.errorMessage]);

  const isShowPregnancy = useMemo(() => {
    return (
      props.selectedPatient?.gender === "F" &&
      props.selectedPatient?.age >= 15 &&
      props.selectedPatient?.age <= 50
    );
  }, [props.selectedPatient]);

  const headersEncounter = useMemo(() => {
    return [
      <Checkbox
        key="encounter-checkbox"
        checked={
          printableList.length ===
            props.CreateUpdateEncounterSequence?.selectedEncounterItems?.length &&
          !!printableList.length
        }
        onChange={handleCheckAll}
      />,
      "Encounter [Episode]",
      "Division",
      "Doctor",
      "Status",
      "Started",
      "Create",
      "Update",
      "Del",
    ].filter((item: any) =>
      !props.useApiDashboard ? !["Update", "Create"].includes(item) : item !== "Started",
    );
  }, [printableList, props.CreateUpdateEncounterSequence?.selectedEncounterItems]);

  const encounterList = useMemo(
    () =>
      (props.CreateUpdateEncounterSequence?.encounterList || []).map((item: any, _idx: any) => {
        const patientCaseOptions = props.masterOptions?.patientCase || [];
        const isTelemed =
          patientCaseOptions
            .find((acc: any) => acc.value === item.patient_case)
            ?.text?.toLowerCase() === "telemed";
        const episodeNo = item.episode_no ? ` [${item.episode_no}]` : "";

        return {
          ...item,
          _doctor: (
            <div style={{ lineHeight: "19px" }}>
              <div>
                {`${item?.doctor_name || ""}  ${
                  item?.student && item?.student !== null ? " /" : ""
                }`}
              </div>

              {item?.student ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={"/static/images/order_images/student.png"}
                    style={{ width: "1.3em", height: "1.3em", marginRight: "5px" }}
                  />
                  {item?.student_name}
                </div>
              ) : null}
            </div>
          ),
          _checked: (
            <div style={{ display: "flex", justifyContent: "center" }}>
              {item.status !== "CANCELED" && (
                <Checkbox
                  checked={props.CreateUpdateEncounterSequence?.selectedEncounterItems?.includes(
                    item.id,
                  )}
                  name={item.id}
                  onChange={handleCheck}
                />
              )}
            </div>
          ),
          number: (
            <div style={{ display: "flex", alignItems: "center" }}>
              {item.number}
              {episodeNo}
              {isTelemed && (
                <img
                  src={IMAGES.call_message_yellow}
                  alt="call message yellow"
                  style={{ width: "17.5px", marginLeft: "1rem" }}
                />
              )}
            </div>
          ),
          delete: (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                color="red"
                content={intl.formatMessage({ id: "ยกเลิก" })}
                size="mini"
                onClick={() => {
                  handleOpenDialog();
                }}
              />
            </div>
          ),
          canceledDate: formatDatetime(item.canceled_date, true),
        };
      }),
    [
      props.CreateUpdateEncounterSequence,
      props.CreateUpdateEncounterSequence?.encounterList,
      props.CreateUpdateEncounterSequence?.selectedEncounterItems,
    ],
  );

  const appointmentList = useMemo(() => {
    let list: any[] = [];

    if (props.useApiDashboard) {
      list =
        (props.patientListMyBplus || []).filter(
          (item: any) => props.selectedPatient?.hn === item.hn,
        ) || [];
    } else {
      list = (props.appointmentEncounterList || []).filter((item: any) => {
        const hasAppointmentDetails = item.date && item.start_time && item.doctor;
        const isPackageAppointment = item.appointment_type === 3;
        const isRehabAppointment = Object.values(item.order_dict || {}).some(
          (value) => value === "rehabilitationorder",
        );

        return hasAppointmentDetails || isPackageAppointment || isRehabAppointment;
      });
    }

    return (list || []).map((item: any) => {
      // package_orders
      let children = item.children || [];
      if (item.appointment_type === 3 && props.appointmentPackageList?.[item.id]) {
        const pkg = props.appointmentPackageList[item.id].package_orders || [];
        children = pkg.map((p: any, index: number) => ({
          id: `${item.id}_pkg_${index}`,
          summary_detail: `<b>[${p.package_code}] ${p.package_name}</b>`,
          type: "package_orders",
        }));
      }

      const generatedOrder = props.useApiDashboard ? [] : generateOrder(children).filter(Boolean);

      const detail = item.is_telemed ? "นัดปรึกษาแพทย์ออนไลน์" : item.detail;

      const physiotherapistNames: string[] = (item.children ?? [])
        .filter((item: any) => item.type === "rehabilitationorder")
        .map((item: any) => item.physiotherapist_fullname)
        .filter(Boolean);

      return {
        ...item,
        children,
        _checked: (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Checkbox
              disabled={props.patient?.profile_status === "NOT_VERIFIED"}
              checked={(props.selectedAppointmentItems || [])?.includes(item?.id)}
              onChange={handleCheckEncounterAppointment(item)}
            />
          </div>
        ),
        order:
          children?.length > 0 ? (
            <div style={{ display: "grid", gridTemplateColumns: "40% 40%" }}>
              {generatedOrder.map((item: any, _index: number) => {
                return (
                  <div key={"order" + item.image} style={{ paddingLeft: "5px" }}>
                    <Popup
                      on="click"
                      trigger={
                        item.image ? (
                          <img
                            src={item.image}
                            alt="order-icon"
                            style={{ width: "30px", height: "30px" }}
                          />
                        ) : (
                          item.icon && (
                            <div
                              style={{
                                width: "32px",
                                height: "32px",
                                backgroundColor: "white",
                                borderRadius: "500rem",
                                display: "flex",
                              }}
                            >
                              <div
                                style={{
                                  width: "30px",
                                  height: "30px",
                                  backgroundColor: "#cccccc",
                                  borderRadius: "500rem",
                                  margin: "auto",
                                  paddingTop: "6px",
                                }}
                              >
                                <Icon
                                  name={item.icon}
                                  inverted
                                  style={{ width: "30px", height: "30px" }}
                                />
                              </div>
                            </div>
                          )
                        )
                      }
                    >
                      {item.items.map((order: any) => htmlParse(order))}
                    </Popup>
                  </div>
                );
              })}
            </div>
          ) : (
            <></>
          ),
        detail: (
          <div>
            {props.patient?.profile_status === "NOT_VERIFIED" ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                <Image height={25} src={IMAGES.mobilePhoneLock} style={{ marginLeft: "10px" }} />
                <div style={{ color: "red", fontSize: "10px" }}>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    {intl.formatMessage({ id: "ยืนยันประวัติ" })}
                  </div>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    ก่อนเปิด Encounter
                  </div>
                </div>
              </div>
            ) : (
              detail
            )}
          </div>
        ),
        doctor_name: (
          <>
            <div>{item.doctor_name}</div>
            {physiotherapistNames.length > 0 && (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "auto 1fr",
                  marginTop: "0.25rem",
                }}
              >
                <div
                  style={{
                    color: "#0d71bb",
                    fontSize: "0.75rem",
                    border: "1px solid #0d71bb",
                    height: "15px",
                    borderRadius: "3px",
                    padding: "0 0.45rem",
                    marginRight: "0.25rem",
                    marginTop: "3px",
                  }}
                >
                  <div style={{ marginTop: "-3px" }}>PT</div>
                </div>
                <div>
                  {physiotherapistNames.map((name, index) => (
                    <div key={`physiotherapist-${index}`}>{name}</div>
                  ))}
                </div>
              </div>
            )}
          </>
        ),
        date: (
          <div style={{ display: "flex", alignItems: "center" }}>
            <span>{item.date}</span>
            {item.is_telemed && (
              <img
                src={IMAGES.call_message_yellow}
                alt="call message yellow"
                style={{ width: "17.5px", marginLeft: "0.5rem" }}
              />
            )}
          </div>
        ),
      };
    });
  }, [
    props.appointmentEncounterList,
    props.appointmentPackageList,
    props.selectedAppointmentItems,
    props.patientListMyBplus,
    props.selectedPatient,
  ]);

  const episodeOptions = useMemo(() => {
    return (props.CreateUpdateEncounterSequence?.episodeList || []).map((item: any) => {
      const episodeType =
        props.masterOptions.episodeType?.find((option) => option.value === item.episode_type)
          ?.text || "";
      const doctorName = item.doctor_name ? `, ${item.doctor_name}` : "";
      const finishText = item.is_finished ? "(Finish) " : "";

      return {
        key: item.id,
        text: `${finishText}${item.episode_no} ${item.name} [${episodeType}]${doctorName}`,
        value: item.id,
        content: (
          <div>
            {finishText}
            <strong>{item.episode_no}</strong> {item.name} [{episodeType}]{doctorName}
          </div>
        ),
      };
    });
  }, [props.masterOptions, props.CreateUpdateEncounterSequence?.episodeList]);

  const defaultDoctorText = useMemo(() => {
    const doctorId = props.CreateUpdateEncounterSequence?.doctor;
    if (!doctorId) return "";
    const fromMaster = (props.masterOptions?.doctor || []).find(
      (item: any) => item.value === doctorId,
    );
    if (fromMaster?.text) return fromMaster.text;
    if (selectedEncounter?.doctor === doctorId && selectedEncounter?.doctor_name) {
      return selectedEncounter.doctor_name;
    }
    return "";
  }, [
    props.CreateUpdateEncounterSequence?.doctor,
    props.masterOptions?.doctor,
    selectedEncounter?.doctor,
    selectedEncounter?.doctor_name,
  ]);

  const searchBoxDoctor = useMemo(
    () => (
      <SearchBoxDropdown
        onEvent={props.onEvent}
        id="CardOpenEncounter"
        type="Doctor"
        style={{ width: "100%", flex: "1" }}
        fluid={true}
        useWithKey={true}
        icon="search"
        limit={20}
        defaultText={defaultDoctorText}
        searchedItemListWithKey={props.searchedItemListWithKey}
        selectedItem={props.CreateUpdateEncounterSequence?.doctor || null}
        setSelectedItem={(value: any) => {
          props.setProp("CreateUpdateEncounterSequence.doctor", value || "");
        }}
      />
    ),
    [
      defaultDoctorText,
      props.CreateUpdateEncounterSequence?.doctor,
      props.onEvent,
      props.searchedItemListWithKey,
      props.setProp,
    ],
  );

  // Handler
  const handleDeleteEncounter = ({ username, password }: any = {}) => {
    props.runSequence({
      sequence: "CreateUpdateEncounter",
      action: "delete",
      username: username,
      password: password,
      note: note,
    });

    handleCloseDialog();
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setNote("");
  };

  const handlePrintVisitSlipForm = () => {
    props.runSequence({
      sequence: "CreateUpdateEncounter",
      action: "print_visit_slip_form",
      card: CARD_OPEN_ENCOUNTER,
    });
  };

  console.log("CardOpenEncounter", props);

  return (
    <div style={{ paddingBottom: "2rem", ...(props.cardStyle || {}) }}>
      <Dimmer active={props.loadingStatus?.[CARD_OPEN_ENCOUNTER]} inverted>
        <Loader inverted>Loading....</Loader>
      </Dimmer>

      <SnackMessage
        onEvent={props.onEvent}
        error={errorMessage.error}
        success={null}
        onClose={() => {
          props.runSequence({
            sequence: "CreateUpdateEncounter",
            action: "clear",
          });
        }}
      />

      <ModAuthen
        titleName={intl.formatMessage({ id: "ระบุเหตุผลยกเลิก Encounter" })}
        titleColor={"blue"}
        open={openDialog}
        onCloseWithDimmerClick={handleCloseDialog}
        onApprove={handleDeleteEncounter}
        onDeny={handleCloseDialog}
      >
        <Form.Field
          label={intl.formatMessage({ id: "เหตุผลการยกเลิก" })}
          style={{ marginBottom: "0.5rem" }}
        />
        <Form.Field>
          <Input fluid={true} value={note} onChange={(e) => setNote(e.target.value)} />
        </Form.Field>
      </ModAuthen>

      <CardOpenEncounterUX
        // edit encounter
        isEditEncounter={props.isEditEncounter}
        useApiDashboard={props.useApiDashboard}
        // Data & Fields
        // appointment data
        appointmentData={appointmentList}
        headersEncounter={headersEncounter}
        // encounter
        showEncounterEditor={showEncounterEditor}
        onOpenEncounter={handleOpenEncounter}
        encounterList={encounterList}
        isShowPregnancy={isShowPregnancy}
        hideStudent={!CONFIG.CUDENT_ENCOUNTER_STUDENT}
        encounterData={props.CreateUpdateEncounterSequence}
        pregnancyData={pregnancyData}
        // options
        divisionOptions={props.masterOptions?.divisionNameCode || []}
        doctorOptions={props.masterOptions?.doctor || []}
        patientCaseOptions={props.masterOptions?.patientCase || []}
        episodeOptions={episodeOptions}
        // callback
        rowProps={handleRowProps}
        changeEncounter={changeEncounter}
        changePregnancy={changePregnancy}
        // Element
        buttonSave={
          <ButtonLoadCheck
            // function
            setProp={props.setProp}
            onClick={handleSaveEncounter}
            // data
            paramKey={ACTION_SAVE}
            buttonLoadCheck={props.buttonLoadCheck?.[ACTION_SAVE]}
            // config
            color={selectedEncounter?.id ? "teal" : "green"}
            title={selectedEncounter?.id !== undefined ? "ล้างหน้าจอเพิ่ม Encounter" : "SAVE"}
            style={{ width: `100%`, minWidth: "max-content" }}
          />
        }
        buttonEdit={
          <ButtonLoadCheck
            // function
            setProp={props.setProp}
            onClick={handleEditEncounter}
            // data
            paramKey={ACTION_UPDATE}
            buttonLoadCheck={props.buttonLoadCheck?.[ACTION_UPDATE]}
            disabled={disabledEditEncounter}
            // config
            color="orange"
            title={intl.formatMessage({ id: "แก้ไข Encounter" })}
            style={{ width: `100%` }}
          />
        }
        appointmentRegisterButton={
          <ButtonLoadCheck
            // function
            setProp={props.setProp}
            onClick={
              props.useApiDashboard
                ? handleSyncEncounterAppointment
                : handleOpenEncounterAppointment
            }
            // data
            paramKey={props.useApiDashboard ? ACTION_SYNC_EN_APP : ACTION_OPEN_EN_APP}
            buttonLoadCheck={
              props.buttonLoadCheck?.[
                props.useApiDashboard ? ACTION_SYNC_EN_APP : ACTION_OPEN_EN_APP
              ]
            }
            disabled={
              props.useApiDashboard
                ? !appointmentList?.length
                : !props.selectedAppointmentItems?.length
            }
            // config
            color="blue"
            name={BUTTON_ACTIONS.open_en_app}
            size="medium"
            title={intl.formatMessage({ id: "ลงทะเบียนจากนัดหมาย" })}
          />
        }
        buttonVisitSlip={
          <ButtonLoadCheck
            // function
            setProp={props.setProp}
            onClick={handlePrintVisitSlipForm}
            // data
            paramKey={ACTION_PRINT_VISIT_SLIP}
            buttonLoadCheck={props.buttonLoadCheck?.[ACTION_PRINT_VISIT_SLIP]}
            disabled={!props.CreateUpdateEncounterSequence?.selectedEncounterItems?.length}
            // config
            color="yellow"
            name={BUTTON_ACTIONS.print_visit_slip_form}
            size="medium"
            title={intl.formatMessage({ id: "พิมพ์บัตรเข้ารับการรักษา" })}
          />
        }
        checkboxDrugPurchase={
          showDrugPurchase ? (
            <Checkbox
              label={intl.formatMessage({ id: "สำหรับซื้อยา" })}
              checked={!!props.CreateUpdateEncounterSequence?.isDrugPurchase}
              disabled={selectedEncounter?.id !== undefined}
              onChange={(_e: any, data: any) => {
                props.setProp("CreateUpdateEncounterSequence.isDrugPurchase", !!data.checked);
              }}
            />
          ) : null
        }
        noResultsMessageEpisode={<div style={{ textAlign: "center" }}>No episode items</div>}
        // Bplus มีหมอเยอะเกินไป จึกเปลี่ยนมาใช้แบบ search แทนแล้วไม่ต้อง get master doctor อีก
        SearchBoxDoctor={searchBoxDoctor}
        isSearch={CONFIG.COMPANY === "BDMS"}
        languageUX={props.languageUX}
      />

      <ModInfo
        open={openErrorVerified}
        titleColor={"red"}
        titleName={intl.formatMessage({ id: "ข้อความแจ้งเตือน" })}
        btnText={intl.formatMessage({ id: "ตกลง" })}
        buttonColor="green"
        onApprove={() => setOpenErrorVerified(false)}
        onClose={() => setOpenErrorVerified(false)}
      >
        <div style={{ padding: "0.5rem 0", fontWeight: "bold", lineHeight: 1.5 }}>
          <div>{intl.formatMessage({ id: "กรุณายืนยันประวัติผู้ป่วยก่อนเปิด Encounter" })}</div>
        </div>
      </ModInfo>

      <ModInfo
        open={openErrorMessageDegree}
        titleColor={"red"}
        titleName={intl.formatMessage({ id: "ข้อความแจ้งเตือน" })}
        btnText={intl.formatMessage({ id: "ปิดหน้าต่าง" })}
        onApprove={() => setOpenErrorMessageDegree(false)}
        onClose={() => setOpenErrorMessageDegree(false)}
      >
        <div style={{ padding: "0.5rem 0", fontWeight: "bold", lineHeight: 1.5 }}>
          <div>{intl.formatMessage({ id: "ไม่สามารถทำการเปิด Encounter ได้" })}</div>
          <div>{intl.formatMessage({ id: "กรุณาทำการระบุระดับของนิสิต/นักศึกษาแพทย์" })}</div>
        </div>
      </ModInfo>

      <ModInfo
        btnText="CONFIRM"
        buttonColor="green"
        buttonDisabled={props.rehabAppointmentDoctors?.every((item: any) => !item.doctor)}
        buttonStyle={{ marginTop: "2rem" }}
        open={!!props.rehabAppointmentDoctors?.length}
        style={{ minWidth: "35rem", width: "max-content" }}
        titleColor={"red"}
        titleName="Alert message"
        closeOnDimmerClick
        onApprove={handleOpenEncounterAppointment}
        onClose={() => {
          props.setProp("rehabAppointmentDoctors", null);
        }}
      >
        <Form size="small" style={{ textAlign: "left" }}>
          <div style={{ fontSize: "1rem", fontWeight: "bold", margin: "1rem 0 0" }}>
            Cannot open the Encounter. Please specify a doctor
          </div>
          {props.rehabAppointmentDoctors?.map((item: any, index: number) => (
            <React.Fragment key={`doctor-${index}`}>
              <div
                style={{
                  fontSize: "1rem",
                  marginBottom: "0.5rem",
                  marginTop: index === 0 ? "1rem" : "1.5rem",
                }}
              >
                <label style={{ fontWeight: "bold" }}>Doctor for appointment : </label>
                {item.date} [{item.start_time}], {item.division_name}
              </div>
              <div style={{ alignItems: "center", display: "flex" }}>
                <label style={{ fontSize: "1rem", marginRight: "0.5rem", minWidth: "max-content" }}>
                  Doctor :{" "}
                </label>
                <Dropdown
                  style={{ width: "100%" }}
                  value={item.doctor}
                  fluid
                  search
                  selection
                  options={props.masterOptions?.doctor}
                  onChange={(e, data) => {
                    props.setProp(`rehabAppointmentDoctors.${index}.doctor`, data.value);
                  }}
                />
              </div>
            </React.Fragment>
          ))}
        </Form>
      </ModInfo>

      <ModConfirmCNMI
        approveButtonText="CONFIRM"
        backgroundColor="red"
        basic={false}
        denyButtonText="CANCEL"
        modalStyle={{ minWidth: "30rem" }}
        openModal={errorMessage.deviceError}
        titleName="Alert message"
        onApprove={() => {
          handleOpenEncounterAppointment({ confirmed: true });
        }}
        onDeny={() => {
          props.runSequence({
            sequence: "CreateUpdateEncounter",
            action: "clear",
          });
        }}
        approveButtonLoading={props.buttonLoadCheck?.[ACTION_OPEN_EN_APP]}
        content={
          <div style={{ margin: "-0.5rem 1rem -1rem" }}>
            <div style={{ fontWeight: "bold" }}>{errorMessage.deviceError?.error}</div>
            <div style={{ margin: "0.75rem 0 0 2rem" }}>
              <ul>
                {errorMessage.deviceError?.detail.map((item: any, index: number) => (
                  <li key={`detail-${index}`}>{item.name}</li>
                ))}
              </ul>
            </div>
          </div>
        }
      />
      <div ref={bottomRef} />
    </div>
  );
};

CardOpenEncounter.displayName = "CardOpenEncounter";

export default React.memo(CardOpenEncounter);
